import React, { useContext } from 'react';
import { AppBar, Toolbar } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import { userContext } from 'context/user';

import { styles } from './styles';
import AppLogo from 'images/app-logo.svg';
import ProfileImage from 'components/common/profile-image';
import BreadcrumbsList from 'components/common/breadcrumb';

import application from 'application.json';

export default function AppHeader() {
  const classes = styles();
  const { currentUser } = useContext(userContext);

  return (
    <AppBar position="fixed" className={classes.root}>
      <Toolbar className={classes.appbarToolbar}>
        <Tooltip title={`IPM Cloud - ${application.version}`} arrow>
          <img
            src={AppLogo}
            className={classes.appLogo}
            alt={application.appName}
          />
        </Tooltip>
        <span className={classes.logoDivider}></span>
        <BreadcrumbsList />
        {Object.entries(currentUser).length !== 0 && (
          <span className={classes.profileImage}>
            <ProfileImage currentUser={currentUser} />
          </span>
        )}
      </Toolbar>
    </AppBar>
  );
}
